import React from 'react'
import { Button, Badge } from 'reactstrap'
import { withPrefix } from "gatsby"

import Layout from '../components/blog/Layout'
import Quotes from '../components/blog/Quotes'
import SEO from '../components/seo'

import { slugify } from '../util/utilityFunctions'


const TagsPage = ({ pageContext }) => {
    // console.log(pageContext)
    const { tags, tagPostCounts, url } = pageContext
    return (
        <Layout pageTitle="Semua Tags"
            location={{ pathname: `${url}` }}
            jokes={["You are CSS to My HTML", "Tanpamu, Hidupku Monoton"]}

        >
            <SEO title="Tags" />
            <div className="container mb-5">
                <div className="row">
                    {tags.map(tag => (
                        <div className="col col-md-3" key={tag} style={{ marginBottom: '10px' }}>
                            <Button color="primary"
                                href={withPrefix(`blog/tag/${slugify(tag)}`)}
                                outline>
                                {tag} <Badge color="secondary">{tagPostCounts[tag]}</Badge>
                            </Button>
                        </div>
                    ))}
                </div>
            </div>
            <Quotes />
        </Layout>
    )
}



export default TagsPage